module.exports = __webpack_public_path__ + "static/media/hero.c129a51a.png";